module.exports = __webpack_public_path__ + "static/media/trademarks.b38a7b68.png";